import { getUseResource } from '../resource';
import { userDownloadsResources } from '../builders/userDownloadsResources';
import { IUserDownloadsResponse } from '../models/IUserDownloads';
import { IUserDownloadFilesResponse } from '../models/IUserDownloads';
import { IUserExamplesResponse } from '../models/IUserExample';
import { IUserEngineContentResponse } from '../models/IUserEngineContent';

export const apiUserDownloads = {
  useListDownloads: getUseResource(userDownloadsResources.listDownloads, (body): IUserDownloadsResponse => body),
  useGetEngineContent: getUseResource(
    userDownloadsResources.getEngineContent,
    (body): IUserEngineContentResponse => body,
    (params, productId: number, version: string) => ({ productId, version })
  ),
  useGetExamples: getUseResource(
    userDownloadsResources.getExamples,
    (body): IUserExamplesResponse => body,
    (params, productId: number, version: string) => ({ productId, version })
  ),
  useGetTools: getUseResource(
    userDownloadsResources.getTools,
    (body): IUserDownloadFilesResponse => body,
    (params, productId: number, version: string) => ({ productId, version })
  ),
  useGetLens: getUseResource(
    userDownloadsResources.getLens,
    (body): IUserDownloadFilesResponse => body,
    (params, productId: number) => ({ productId })
  ),
  useGetFile: getUseResource(
    userDownloadsResources.getFile,
    (body): { url: string } => body,
    (params, fileName: string) => ({ fileName })
  ),
  useGetFileSilent: getUseResource(
    userDownloadsResources.getFile,
    (body): { url: string } => body,
    (params, fileName: string) => ({ fileName }),
    void 0,
    void 0,
    { indicateLoading: false }
  ),
};
